import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import { Dispatch, bindActionCreators } from "redux";

import { Overlay } from "@plex/react-components";

import { Banner } from "ui/app";

import { MessagesActionBar as ActionBar } from "./actionBar";
import { MessagesFilter as Filter } from "./filter";
import { MessagesGrid as Grid } from "./grid";
import { messagesActions } from "./Messages.actions";
import { IMessagesState } from "./Messages.state";

interface IMessagesProps {
  state: IMessagesState;
  initialize: () => void;
}

export const Messages: React.FC<IMessagesProps & RouteComponentProps> = ({ state, initialize }) => {
  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <>
      <Overlay show={state.isLoading} showSpinner />
      <Banner messages={state.notifications} />
      <Filter />
      <ActionBar />
      <Grid />
    </>
  );
};

export default connect(
  (state: { messages: IMessagesState }) => {
    return {
      state: state.messages
    };
  },
  (dispatch: Dispatch) => {
    return bindActionCreators(
      {
        initialize: messagesActions.initialize
      },
      dispatch
    );
  }
)(Messages);
